import React from 'react';
import { Props } from '../../GalleryView';
import Grid from '../../../../Grid/Grid';
import EditorDeviationLink from '../../../MonoView/_partials/DeviationLink';
import Thumb from '../../../ThumbView';

const GalleryGrid: React.FC<Props> = ({
  deviations,
  layoutRowAlignment,
  width,
  layoutSpacing,
  extOptions,
  gridItemWidth,
  gridItemHeight,
  itemCropping,
  linkOverrides,
}) => {
  const getId = (idx: number) => deviations[idx].deviationId;
  width = isNaN(width) ? 780 : width;

  let breakpoints = [
    {
      maxWidth: 9999,
      elementWidth: gridItemWidth ?? extOptions.defaultGridItemWidth,
      elementHeight: gridItemHeight || extOptions.defaultGridItemHeight,
    },
  ];

  // Comments force small media
  if (extOptions.smallMedia) {
    breakpoints = [
      {
        maxWidth: 9999,
        elementWidth: extOptions.defaultGridItemWidth,
        elementHeight: extOptions.defaultGridItemHeight,
      },
    ];
  }

  let gridStyles: React.CSSProperties = {};
  let rowAlign;
  if (layoutRowAlignment) {
    const settingToCss = {
      left: 'flex-start',
      right: 'flex-end',
      center: 'center',
    };
    gridStyles = {
      display: 'flex',
      justifyContent: settingToCss[layoutRowAlignment],
    };
    rowAlign = layoutRowAlignment;
  }

  return (
    <div style={gridStyles} className="daeditor-square-grid">
      <Grid
        rowAlign={rowAlign}
        containerWidth={width}
        breakpoints={breakpoints}
        elementCount={deviations.length}
        spacing={layoutSpacing ?? extOptions.defaultLayoutSpacing}
        rowSpacing={layoutSpacing ?? extOptions.defaultLayoutSpacing}
        getElementId={getId}
        enableScrollOptim={false}
        renderElement={element => (
          <div
            key={element.index}
            style={{
              ...element.style,
            }}
            data-deviation={JSON.stringify(deviations[element.index])}
          >
            <EditorDeviationLink
              link={
                extOptions?.canLink
                  ? linkOverrides?.[deviations[element.index].deviationId]
                  : undefined
              }
              deviation={deviations[element.index]}
              data-deviationId={
                extOptions?.canLink
                  ? deviations[element.index].deviationId
                  : undefined
              }
            >
              <Thumb
                deviation={deviations[element.index]}
                width={element.width}
                height={element.height}
                allowPreviewUsage
                noCropping={itemCropping === 'fit' ? true : false}
              />
            </EditorDeviationLink>
          </div>
        )}
      />
    </div>
  );
};
GalleryGrid.displayName = 'GalleryGrid';

export default GalleryGrid;
